export type FlowIconName = "pin" | "fuel" | "document" | "send";

export const navItems = [
  { label: "Prețuri", href: "/#preturi" },
  { label: "Ghiduri", href: "/#ghiduri" },
  { label: "Noutăți", href: "/#noutati" },
  { label: "Întrebări", href: "/#intrebari-frecvente" },
  { label: "Despre noi", href: "/#visajtech" },
];

export const resourceLinks = [
  { label: "Ghid foaie de parcurs ANAF", href: "/ghid-foaie-parcurs-anaf" },
  { label: "Deducere 100% combustibil", href: "/deducere-100-combustibil" },
  { label: "Foi de parcurs pentru PFA", href: "/foi-parcurs-pfa" },
  { label: "Model foaie de parcurs", href: "/model-foaie-parcurs" },
  {
    label: "Control ANAF cheltuieli autoturism",
    href: "/control-anaf-cheltuieli-autoturism",
  },
  {
    label: "Automatizare foi de parcurs",
    href: "/automatizare-foi-de-parcurs",
  },
  { label: "Foi de parcurs și comodat", href: "/foi-parcurs-comodat" },
  { label: "Traseul casă–serviciu", href: "/foaie-parcurs-casa-serviciu" },
  { label: "Norma de consum", href: "/norma-de-consum-foaie-parcurs" },
];

export const heroHighlights = [
  "Diferența dintre 50% și 100% se simte direct în bani",
  "Mai bine pregătit la control",
  "Mai puțină muncă manuală, mai puține erori",
];

export const heroFlow: Array<{
  icon: FlowIconName;
  description: string;
  featured?: boolean;
  success?: boolean;
}> = [
  {
    icon: "pin",
    description: "Introduci locațiile frecvente și deplasările ocazionale",
  },
  {
    icon: "fuel",
    description: "Adaugi alimentările și kilometrii din bord",
  },
  {
    icon: "document",
    description:
      "Foile lipsă se completează automat și se validează coerența dintre kilometri, consum și rezervor.",
    featured: true,
  },
  {
    icon: "send",
    description: "Verifici rezultatul și trimiți la contabil",
    success: true,
  },
];

export const problemCards = [
  {
    label: "Impact financiar",
    stat: "50%",
    title: "Pierzi jumătate din deducere",
    description:
      "Pentru contabil poate fi mai simplu. Pentru tine, înseamnă bani pierduți lună de lună, fără să vezi cât se adună. În contextul actual, nu mai e de amânat.",
  },
  {
    label: "Risc fiscal",
    stat: "ANAF",
    title: "Riști penalități foarte mari",
    description:
      "Deduci 100% dar ai restanțe la întocmirea foilor de parcurs de luni sau ani? La primul control riști să pierzi mii de euro.",
  },
  {
    label: "Timp pierdut",
    stat: "EFORT",
    title: "Prea multe verificări manuale",
    description:
      "Pierzi câteva ore pe lună, pe fiecare vehicul, cu completarea foilor de parcurs, potrivind trasee, kilometri, consum și rezervor.",
  },
];

export const aboutSection = {
  eyebrow: "Cine a făcut aplicația",
  title: "VisajTech",
  description:
    "AIFoiParcurs este primul produs Visaj Technologies: foi de parcurs complete, validate și gata de trimis la contabil.",
  visajtechUrl: "https://www.visajtech.com/",
};

export const aboutCards = [
  {
    title: "Firma",
    href: "https://www.visajtech.com/",
    description:
      "Visaj Technologies dezvoltă software AI pentru operațiuni reale din companii: automatizare aplicată, date corelate și fluxuri pe care echipele le pot folosi zi de zi — nu demonstrații.",
  },
  {
    title: "Fondator",
    href: "https://www.visajtech.com/founder",
    description:
      "Sasa Cioringa, fondator și CEO. Peste 20 de ani în automotive și tehnologie; anterior General Manager al Continental Automotive Serbia, unde a construit și condus organizații de inginerie.",
  },
];

export const solutionBullets = [
  {
    title: "Poți porni de la zero",
    description:
      "Dacă nu ai făcut foi de parcurs până acum, poți începe simplu, fără să reconstruiești totul manual.",
  },
  {
    title: "Poți recupera perioade restante",
    description:
      "Dacă ai luni sau ani în urmă neacoperiți, poți reconstrui ușor și rapid perioadele lipsă.",
  },
  {
    title: "Poți scăpa de munca manuală",
    description:
      "Dacă ai foile la zi, dar le faci manual, aplicația pentru foi de parcurs reduce timpul pierdut pe completare și verificări.",
  },
  {
    title: "Poți importa datele deja existente",
    description:
      "Dacă ai card de combustibil sau fișa de la contabil, alimentările se pot importa automat pentru foile de parcurs online.",
  },
];

/** Factor pentru prețul de referință „ca și cu TVA 21%” (doar afișare). */
export const LANDING_LEGACY_TVA_FACTOR = 1.21;

export type LandingPlan = {
  name: string;
  /** Total EUR/lună pentru minim 3 vehicule; nu se aplică TVA (sumă datorată). */
  eurMonthlyTotalMin: number;
  caption: string;
  details: string[];
  featured?: boolean;
};

export const plans: LandingPlan[] = [
  {
    name: "Lunar",
    eurMonthlyTotalMin: 7.5,
    caption: "total minim / lună (nu se aplică TVA)",
    details: [
      "2.5 EUR / vehicul / lună",
      "+2.5 EUR / lună pentru fiecare vehicul peste prag",
    ],
  },
  {
    name: "3 luni",
    eurMonthlyTotalMin: 6.75,
    caption: "total minim / lună echivalent (nu se aplică TVA)",
    details: [
      "-10% față de lunar",
      "2.25 EUR / vehicul / lună",
      "+2.25 EUR / lună pentru fiecare vehicul peste prag",
    ],
  },
  {
    name: "Anual",
    eurMonthlyTotalMin: 6,
    caption: "total minim / lună echivalent (nu se aplică TVA)",
    details: [
      "-20% față de lunar",
      "2 EUR / vehicul / lună",
      "+2 EUR / lună pentru fiecare vehicul peste prag",
    ],
    featured: true,
  },
];

/** Cel mai mic total lunar echivalent (plan anual, 3 vehicule). */
export const LANDING_MIN_EUR_MONTHLY = 6;

export const freePlanDetails = ["până la 3 vehicule", "fără card", "2 luni gratis"];

export const retroactiveDetails = [
  "1-3 luni selectate: 2.5 EUR",
  "4-12 luni selectate: 2.2 EUR",
  "peste 12 luni selectate: 2.0 EUR",
];

export type LandingNewsBadge =
  | "ANAF"
  | "Deductibilitate"
  | "Automatizare"
  | "Fiscalitate"
  | "Foaie de parcurs"
  | "Documente";

export type LandingNewsItem = {
  title: string;
  description: string;
  href: string;
  linkLabel: string;
  badge: LandingNewsBadge;
  /** ISO date for <time datetime>; display via dateLabel */
  dateIso: string;
  dateLabel: string;
  readingMinutes: number;
  coverSrc: string;
  coverAlt: string;
};

/** Secțiunea Ghiduri: textele publice (aceleași ca lista din subsol). */
export const ghiduriSection = {
  eyebrow: "Ghiduri",
  title: "Ghiduri pentru foi de parcurs",
  description:
    "Cerințe ANAF, deducere 100%, PFA, model, control, automatizare, comodat, casă–serviciu și norma de consum.",
};
export const newsSection = {
  eyebrow: "Noutăți",
  title: "Noutăți AIFoiParcurs",
  description:
    "Aici găsești actualizări legislative, funcționalități noi ale aplicației și articole utile despre foile de parcurs, fiscalitate și administrarea autovehiculelor firmei.",
};

export const newsItems: LandingNewsItem[] = [
  {
    badge: "Fiscalitate",
    dateIso: "2026-09-14",
    dateLabel: "14 septembrie 2026",
    readingMinutes: 4,
    title: "Mașina personală folosită de SRL: comodat, decont km și foaie de parcurs",
    description:
      "Când autoturismul e pe numele administratorului, cheltuielile nu trec automat pe SRL. Fără drept de folosință, bonurile pe CUI nu țin la control.",
    linkLabel: "Citește articolul",
    href: "/masina-personala-srl-comodat",
    coverSrc: "/articles/masina-personala-srl-cover.svg",
    coverAlt: "Mașina personală folosită de SRL — comodat și decont de kilometri",
  },
  {
    badge: "Deductibilitate",
    dateIso: "2026-10-01",
    dateLabel: "1 octombrie 2026",
    readingMinutes: 5,
    title: "Autoutilitară sau autoturism: când deduci 100% și când îți trebuie foaie de parcurs",
    description:
      "Mențiunea N1 din talon nu dă deducere integrală. Sub 3,5 tone și cu cel mult 9 locuri, dubița urmează aceeași regulă ca autoturismul.",
    linkLabel: "Citește articolul",
    href: "/autoutilitara-vs-autoturism-deductibilitate",
    coverSrc: "/articles/autoutilitara-vs-autoturism-cover.svg",
    coverAlt: "Autoutilitară și autoturism — masa, locurile și deducerea",
  },
  {
    badge: "Documente",
    dateIso: "2026-09-28",
    dateLabel: "28 septembrie 2026",
    readingMinutes: 4,
    title: "Bon fiscal vs factură la combustibil: ce acceptă ANAF",
    description:
      "Bonul e suficient la pompă. Factura e mai sigură la control. Diferența contează când vrei 100% și inspectorul cere legătura dintre documente și foaie.",
    linkLabel: "Citește articolul",
    href: "/bon-fiscal-vs-factura-combustibil",
    coverSrc: "/articles/bon-factura-cover.png",
    coverAlt: "Bon fiscal vs factură la combustibil — documente justificative",
  },
  {
    badge: "Deductibilitate",
    dateIso: "2026-09-27",
    dateLabel: "27 septembrie 2026",
    readingMinutes: 4,
    title: "Regulament intern pentru autoturismul de firmă",
    description:
      "La 100%, foaia nu e suficientă. Îți trebuie și un regulament care interzice folosirea personală, semnat înainte de perioada pe care o deduci.",
    linkLabel: "Citește articolul",
    href: "/regulament-intern-autoturism",
    coverSrc: "/articles/regulament-intern-cover.svg",
    coverAlt: "Regulament intern pentru autoturismul de firmă — clauze și semnături",
  },
  {
    badge: "Documente",
    dateIso: "2026-09-28",
    dateLabel: "28 septembrie 2026",
    readingMinutes: 4,
    title: "Bon fiscal vs factură la combustibil: ce acceptă ANAF",
    description:
      "Bonul e suficient la pompă. Factura e mai sigură la control. Diferența contează când vrei 100% și inspectorul cere legătura dintre documente și foaie.",
    linkLabel: "Citește articolul",
    href: "/bon-fiscal-vs-factura-combustibil",
    coverSrc: "/articles/bon-factura-cover.png",
    coverAlt: "Bon fiscal vs factură la combustibil — documente justificative",
  },
  {
    badge: "Deductibilitate",
    dateIso: "2026-10-01",
    dateLabel: "1 octombrie 2026",
    readingMinutes: 5,
    title: "Autoutilitară sau autoturism: când deduci 100% și când îți trebuie foaie de parcurs",
    description:
      "Mențiunea N1 din talon nu dă deducere integrală. Sub 3,5 tone și cu cel mult 9 locuri, dubița urmează aceeași regulă ca autoturismul.",
    linkLabel: "Citește articolul",
    href: "/autoutilitara-vs-autoturism-deductibilitate",
    coverSrc: "/articles/autoutilitara-vs-autoturism-cover.svg",
    coverAlt: "Autoutilitară și autoturism — masa, locurile și deducerea",
  },
  {
    badge: "Documente",
    dateIso: "2026-10-05",
    dateLabel: "5 octombrie 2026",
    readingMinutes: 4,
    title: "Decont de kilometri: când îl folosești în loc de combustibil pe firmă",
    description:
      "Câteva curse pe lună cu mașina personală se plătesc lei/km. Carburantul rămâne al persoanei. Decontul și bonurile pe aceiași kilometri sunt dublare.",
    linkLabel: "Citește articolul",
    href: "/decont-kilometri",
    coverSrc: "/articles/decont-kilometri-cover.svg",
    coverAlt: "Decont de kilometri — traseu și plată către persoana fizică",
  },
];

/** SPA routes — served by React Router (see App.tsx). */
export const legalLinks = [
  { label: "Termeni și condiții", href: "/termeni-si-conditii" },
  { label: "Politica de confidențialitate", href: "/politica-de-confidentialitate" },
  { label: "Politica GDPR", href: "/politica-gdpr" },
  { label: "Politica de livrare", href: "/politica-de-livrare" },
  { label: "Politica de anulare comandă", href: "/politica-de-rambursare" },
];
